export default __webpack_public_path__ + "static/media/Reception Lobby1.4e84e3a5.jpg";